

export class GeofenceStatusInput implements IGeofenceStatusInput {
    /** The auto-generated id of the geofence master */
    geofenceId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IGeofenceStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geofenceId = _data["geofenceId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GeofenceStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new GeofenceStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geofenceId"] = this.geofenceId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGeofenceStatusInput {
    /** The auto-generated id of the geofence master */
    geofenceId: number;
    /** The updated status */
    status: number;
}

